import { createStaticVNode, defineComponent, openBlock, createElementBlock } from 'vue';

const _hoisted_1 = {
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g id="p1-\u898F\u7BC4\u8207\u5207\u5716" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="p1-\u5207\u5716" transform="translate(-298.000000, -448.000000)"><g id="icon_header_logged" transform="translate(298.000000, 448.000000)"><rect id="bg" x="0" y="0" width="32" height="32"></rect><circle id="\u692D\u5706\u5F62" stroke="#FFFFFF" stroke-width="1.4" fill="#0062A3" cx="25" cy="25" r="6.3"></circle><path id="\u8DEF\u5F84" d="M27.324521,22.9266742 L24.621,25.629 L23.3340317,24.3424175 C23.0620684,24.0889029 22.6441903,24.0962866 22.3850087,24.3554646 C22.1258271,24.6146426 22.1184376,25.0325206 22.3682938,25.3007001 L24.1407214,27.0732603 C24.4065183,27.3387291 24.8370062,27.3387291 25.1027376,27.0733258 L28.2865372,23.8895262 C28.5519761,23.6237593 28.5519761,23.1934102 28.2864717,22.9266742 C28.0207403,22.6612709 27.5902524,22.6612709 27.324521,22.9266742 Z" fill="#FFFFFF" fill-rule="nonzero"></path></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
const __default__ = defineComponent({
  name: "TvbLogged"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  setup(__props) {
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Logged.vue2.mjs.map
